import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageComponent } from './language.component';

@NgModule({
    imports: [
        CommonModule
     ],
    declarations: [
        LanguageComponent
    ],
    exports: [
      LanguageComponent
    ]
})
export class LanguageModule {}